// Light background shared tokens for "(White BG)" variants
const WHITE_BG = {
  "--rud-bg": "#F4F4F5", "--rud-surface": "#FFFFFF", "--rud-elevated": "#EEEEF1",
  "--rud-text": "#0A0A0A", "--rud-text-sec": "#52525B", "--rud-border": "rgba(0,0,0,0.12)",
};

export const THEMES = {
  mono: {
    label: "Monochrome (White BG)", "--rud-bg": "#E9E9E9", "--rud-surface": "#FFFFFF",
    "--rud-elevated": "#F2F2F2", "--rud-text": "#000000", "--rud-text-sec": "#000000",
    "--rud-muted": "#000000", "--rud-brand": "#0A0A0A", "--rud-brand-2": "#333333",
    "--rud-border": "rgba(0,0,0,0.14)", swatch: "#FFFFFF",
  },
  mono_dark: {
    label: "Monochrome (Black BG)", "--rud-bg": "#050505", "--rud-surface": "#0C0C0C",
    "--rud-elevated": "#161616", "--rud-text": "#FFFFFF", "--rud-text-sec": "#B4B4B4",
    "--rud-brand": "#FFFFFF", "--rud-brand-2": "#CCCCCC", "--rud-border": "rgba(255,255,255,0.16)", swatch: "#0A0A0A",
  },
  cosmic: {
    label: "Cosmic Void (Black BG)", "--rud-bg": "#05050A", "--rud-surface": "#0A0A0F",
    "--rud-elevated": "#111116", "--rud-text": "#F4F4F5", "--rud-text-sec": "#A1A1AA",
    "--rud-brand": "#FF9D00", "--rud-brand-2": "#007AFF", swatch: "#FF9D00",
  },
  cosmic_light: {
    label: "Cosmic (White BG)", ...WHITE_BG, "--rud-brand": "#E68A00", "--rud-brand-2": "#007AFF", swatch: "#FF9D00",
  },
  sunrise: {
    label: "Sunrise (Black BG)", "--rud-bg": "#160A06", "--rud-surface": "#1E0E08",
    "--rud-elevated": "#28150C", "--rud-text": "#FFF3E8", "--rud-text-sec": "#E4B99A",
    "--rud-brand": "#FF7A1A", "--rud-brand-2": "#FFC24B", swatch: "#FF7A1A",
  },
  sunrise_light: {
    label: "Sunrise (White BG)", ...WHITE_BG, "--rud-brand": "#E85D00", "--rud-brand-2": "#F59E0B", swatch: "#FF7A1A",
  },
  forest: {
    label: "Forest (Black BG)", "--rud-bg": "#06110C", "--rud-surface": "#08170F",
    "--rud-elevated": "#0C2016", "--rud-text": "#ECFDF5", "--rud-text-sec": "#9BC7B0",
    "--rud-brand": "#34D399", "--rud-brand-2": "#A3E635", swatch: "#34D399",
  },
  forest_light: {
    label: "Forest (White BG)", ...WHITE_BG, "--rud-brand": "#0F9D6B", "--rud-brand-2": "#65A30D", swatch: "#34D399",
  },
  azure: {
    label: "Azure Sky (Black BG)", "--rud-bg": "#060B18", "--rud-surface": "#08101F",
    "--rud-elevated": "#0C1628", "--rud-text": "#EFF6FF", "--rud-text-sec": "#9DB4D4",
    "--rud-brand": "#38BDF8", "--rud-brand-2": "#6366F1", swatch: "#38BDF8",
  },
  azure_light: {
    label: "Azure Sky (White BG)", ...WHITE_BG, "--rud-brand": "#0284C7", "--rud-brand-2": "#4F46E5", swatch: "#38BDF8",
  },
  sea: {
    label: "Deep Sea (Black BG)", "--rud-bg": "#03121A", "--rud-surface": "#051A24",
    "--rud-elevated": "#082530", "--rud-text": "#ECFEFF", "--rud-text-sec": "#8FC4CE",
    "--rud-brand": "#22D3EE", "--rud-brand-2": "#2DD4BF", swatch: "#22D3EE",
  },
  sea_light: {
    label: "Deep Sea (White BG)", ...WHITE_BG, "--rud-brand": "#0891B2", "--rud-brand-2": "#0D9488", swatch: "#22D3EE",
  },
  moonlight: {
    label: "Moonlight (Black BG)", "--rud-bg": "#0A0A14", "--rud-surface": "#0F0F1C",
    "--rud-elevated": "#161628", "--rud-text": "#F5F3FF", "--rud-text-sec": "#B4AED3",
    "--rud-brand": "#C4B5FD", "--rud-brand-2": "#818CF8", swatch: "#C4B5FD",
  },
  moonlight_light: {
    label: "Moonlight (White BG)", ...WHITE_BG, "--rud-brand": "#7C3AED", "--rud-brand-2": "#4F46E5", swatch: "#C4B5FD",
  },
  desert: {
    label: "Desert (Black BG)", "--rud-bg": "#161009", "--rud-surface": "#1D160C",
    "--rud-elevated": "#271D11", "--rud-text": "#FDF6E3", "--rud-text-sec": "#D4B98C",
    "--rud-brand": "#F59E0B", "--rud-brand-2": "#EF7C3A", swatch: "#F59E0B",
  },
  desert_light: {
    label: "Desert (White BG)", ...WHITE_BG, "--rud-brand": "#D97706", "--rud-brand-2": "#EA580C", swatch: "#F59E0B",
  },
};

export function applyTheme(name) {
  const t = THEMES[name] || THEMES.mono;
  const root = document.documentElement;
  Object.entries(t).forEach(([k, v]) => {
    if (k.startsWith("--")) root.style.setProperty(k, v);
  });
  const isLight = name === "mono" || name.endsWith("_light");
  root.classList.toggle("theme-mono", isLight);
}
